import { MainMenu } from '@/components/MainMenu';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { SidebarTrigger } from '@/components/ui/sidebar';

import { useIsMobile } from '@/hooks';

import { getNameInitials } from '@/helpers';

import { SidebarMenuProps } from '@/types';

import { ClientQuickSearchForm } from './ClientQuickSearchForm';
import { LocationSwitcher } from './LocationSwitcher';
import { Logo } from './Logo';
import { UiVersionToggle } from './UiVersionToggle';

export const Header = (props: SidebarMenuProps) => {
  const {
    location_props,
    user_name,
    company_id,
    sections,
    active_section_key,
    is_location_switcher_visible,
    is_v2_preview_allowed,
  } = props;
  const isMobile = useIsMobile();
  const activeSection =
    sections.find((section) => section.key === active_section_key) ??
    sections[0];
  const userInitials = getNameInitials(user_name);

  return (
    <header
      data-slot="app-header"
      className="bg-card text-foreground border-border sticky top-0 z-50 flex h-(--header-height) w-full items-center justify-between gap-2 border-b px-4"
    >
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <Logo className="h-8 w-auto shrink-0" />
        {isMobile && <SidebarTrigger />}
        <MainMenu
          sections={sections}
          activeSection={activeSection}
        />
        <ClientQuickSearchForm
          companyId={company_id}
          className={isMobile ? 'w-auto min-w-0 flex-1' : undefined}
        />
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <div className="flex min-w-0 items-center gap-2 pr-2.5 pl-1">
          <Avatar>
            <AvatarFallback>{userInitials}</AvatarFallback>
          </Avatar>
          {!isMobile && (
            <span className="text-foreground max-w-35 truncate text-sm font-medium">
              {user_name}
            </span>
          )}
        </div>
        <div className="flex items-center gap-1">
          {is_v2_preview_allowed && <UiVersionToggle companyId={company_id} />}
          {!isMobile && is_location_switcher_visible && (
            <LocationSwitcher {...location_props} />
          )}
        </div>
      </div>
    </header>
  );
};
